import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior () {
		return {
			x: 0,
			y: 0
		}
	},
	routes: [
		{
			path: '/about',
			name: 'homeGuest',
			component: () => import('./views/HomeGuest.vue'),
			meta: {
				requiresAuth: false,
			},		
		},
		{
			path: '/login',
			component: () => import('./views/Auth/Login.vue'),
			meta: {
				role: 'Client',
				requiresAuth: false,
			}
		},
		{
			path: '/loginAuthor',
			component: () => import('./views/Auth/Login.vue'),
			meta: {
				role: 'Author',
				requiresAuth: false,
			}
		},
		{
			path: '/loginAdmin',
			component: () => import('./views/Auth/Login.vue'),
			meta: {
				role: 'Admin',
				requiresAuth: false,
			}
		},
		{
			path: '/loginPartner',
			component: () => import('./views/Auth/Login.vue'),
			meta: {
				role: 'Partner',
				requiresAuth: false,
			}
		},
		{
			path: '/loginSupervisor',
			component: () => import('./views/Auth/Login.vue'),
			meta: {
				role: 'Supervisor',
				requiresAuth: false,
			}
		},
		{
			path: '/reset',
			component: () => import('./views/Auth/Reset.vue'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '/register',
			component: () => import('./views/Auth/Register.vue'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '/registrationAuthor',
			component: () => import('./views/Auth/Register.vue'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '',
			component: () => import('./layouts/Main.vue'),
			meta: {
				requiresAuth: true
			},
			children: [
				{
					path: '/',
					name: 'home',
					component: () => import('./views/Home.vue'),
					meta: {
						requiresAuth: true
					},		
				},
				// Типы работ
				{
					path: '/typeWorks',
					component: () => import('./views/typeWorks.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Типы работ
				{
					path: '/exchange',
					component: () => import('./views/Exchange.vue'),
					meta: {
						role: 'Author',
					}
				},
				// Клиенты
				{
					path: '/clients',
					component: () => import('./views/Clients/list.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/client/:id',
					component: () => import('./views/Clients/Card.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/client/:id/edit',
					component: () => import('./views/Clients/Edit.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Клиенты
				{
					path: '/clientsM',
					component: () => import('./views/ClientsManager/list.vue'),
					meta: {
						role: ['Manager', 'Supervisor'],
					}
				},
				{
					path: '/clientM/:id',
					component: () => import('./views/ClientsManager/Card.vue'),
					meta: {
						role: ['Manager', 'Supervisor'],
					}
				},
				{
					path: '/clientM/:id/edit',
					component: () => import('./views/ClientsManager/Edit.vue'),
					meta: {
						role: 'Manager',
					}
				},
				// Клиенты для партнеров
				{
					path: '/clientsM',
					component: () => import('./views/ClientsManager/list.vue'),
					meta: {
						role: 'Partner',
					}
				},
				{
					path: '/clientM/:id',
					component: () => import('./views/ClientsManager/Card.vue'),
					meta: {
						role: 'Partner',
					}
				},
				// Авторы
				{
					path: '/authorM/:id',
					component: () => import('./views/AuthorsM/Card.vue'),
					meta: {
						role: 'Manager',
					}
				},
				{
					path: '/authors',
					component: () => import('./views/Authors/list.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/author/:id',
					component: () => import('./views/Authors/Card.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/author/:id/edit',
					component: () => import('./views/Authors/edit.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Тарифная сетка для автора
				{
					path: '/author/:id/tariff/:item',
					component: () => import('./views/Authors/TariffSchedule.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Список отдельных элементов с индивидуальными ценами тарифов для авторов
				{
					path: '/author/:id/tariff-point',
					component: () => import('./views/Authors/TariffPoint.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Последние сообщения менеджера
				{
					path: '/manager/last-messanges',
					component: () => import('./views/Managers/lastMassages.vue'),
					meta: {
						role: 'Manager',
					}
				},
				// Чаты Whatsapp
				// {
				// 	path: '/whatsapp/list-chats-wazzup',
				// 	component: () => import('./views/Whatsapp/ListChatsWazzup.vue'),
				// 	meta: {
				// 		role: [ 'Admin', 'Manager'],
				// 	}
				// },
				// Окрытие чата whatsapp
				{
					path: '/whatsapp/open-chat-whatsapp/:id',
					component: () => import('./views/Whatsapp/OpenChatWhatsapp.vue'),
					meta: {
						role: [ 'Admin', 'Manager'],
					}
				},
				// Dashboard для Whatsapp
				{
					path: '/whatsapp/dashboard',
					component: () => import('./views/Whatsapp/DashboardWhatsapp.vue'),
					meta: {
						role: [ 'Admin', 'Manager'],
					}
				},
				// Списки каналов для Whatsapp
				{
					path: '/whatsapp/list-channel-whatsapp',
					component: () => import('./views/Whatsapp/ListChannelWhatsapp.vue'),
					meta: {
						role: [ 'Admin', 'Manager'],
					}
				},
				// Настройка канала Whatsapp
				{
					path: '/whatsapp/channels/edit/:id',
					component: () => import('./views/Whatsapp/ChannelOneItem.vue'),
					meta: {
						role: [ 'Admin'],
					}
				},
				// Финансы
				{
					path: '/finance',
					component: () => import('./views/Finances/mainFinances.vue'),
				},
				// Менеджеры
				{
					path: '/managers',
					component: () => import('./views/Managers/list.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/create',
					component: () => import('./views/Managers/EditManager.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/duty-schedule',
					component: () => import('./views/Managers/DutySchedule.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/:id',
					component: () => import('./views/Managers/Manager.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/:id/edit',
					component: () => import('./views/Managers/EditManager.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/:id/edit-sites',
					component: () => import('./components/profile/ManagerSitesProfiles.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Сайты
				{
					path: '/sites',
					component: () => import('./views/Sites/List.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/sites/:mode/:id?',
					component: () => import('./views/Sites/Item.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/profile/sites',
					component: () => import('./components/profile/ManagerSitesProfiles.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Партнеры
				{
					path: '/partners',
					component: () => import('./views/Partners/List.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/partners/:mode/:id?',
					component: () => import('./views/Partners/Item.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Шаблонные ответы v1
				{
					path: '/templates',
					component: () => import('./views/Templates.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Шаблонные ответы v2
				{
					path: '/chat-templates',
					component: () => import('./views/ChatTemplates.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Профиль
				{
					path: '/profile',
					name: 'profile',
					component: () => import('./views/Profile')
				},
				{
					path: '/profile/edit',
					name: 'profileEdit',
					component: () => import('./views/EditProfile')
				},
				// Заказы
				{
					path: '/orders',
					name: 'orders',
					component: () => import('./views/Orders/Orders')
				},
				{
					path: '/orders/create',
					name: 'createOrder',
					component: () => import('./views/Orders/CreateOrder')
				},
				{
					path: '/order/:id',
					name: 'order',
					component: () => import('./views/Orders/Order')
				},
				// Тех.поддержка
				{
					path: '/support',
					name: 'supportList',
					component: () => import('./views/Support/List')
				},
				{
					path: '/support/:id',
					name: 'supportCard',
					component: () => import('./views/Support/Card')
				},
				// Дела
				{
					path: 'tasks',
					name: 'tasks',
					component: () => import('./views/Affairs/Affairs')
				},
				{
					path: 'author-tasks',
					name: 'author-tasks',
					component: () => import('./views/AuthorTasks/ListAuthorTasks'),
					meta: {
						role: 'Author',
					},
				},
				{
					path: 'my-authors-tasks',
					name: 'my-authors-tasks',
					component: () => import('./views/Managers/ListMyAuthorsTasks'),
					meta: {
						role: 'Author',
					},
				},
				// Статистика
				{
					path: 'stats',
					name: 'stats',
					component: () => import('./views/Stats/Stats')
				},
				// Логи
				{
					path: 'logs',
					name: 'logs', 
					component: () => import('./views/Logs/ListLog'),
					meta: {
						role: 'Admin',
					}
				},

				// Tickets
				{
					path: '/tickets',
					name: 'Tickets',
					component: () => import('./views/Tickets/List'),
				},
				{
					path: '/ticket/create',
					name: 'TicketsCreate',
					component: () => import('./views/Tickets/Create')
				},
				{
					path: '/ticket/create/:clientId',
					name: 'ClientTicketsCreate',
					component: () => import('./views/Tickets/Create')
				},
				{
					path: '/ticket/:id',
					name: 'TicketsCard',
					component: () => import('./views/Tickets/Card'),
				},
				// AI сстраницы
				{
					path: '/ticket/ai/:id',
					name: 'TicketsCardAi',
					component: () => import('./views/Tickets/Ai'),
				}
			]
		},
		{
			path: '/token/:role/:token',
			component: () => import('./views/Token'),
		},
		{
			path: '/404',
			component: () => import('./views/Error404')
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
})

router.afterEach(() => {
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = 'none'
	}
})
router.beforeEach((to, from, next) => {
	if(to.matched.some(record => record.meta.requiresAuth === false)) {
		if(store.getters.isLoggedIn) {
			next("/");
		} else {
			next();
		}

		return;
	}

	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next();
			return;
		}
		next('/about')
	} else {
		next()
	}
})

export default router
